export const onAddDialogDone = token => ({
  widget: 'tokens',
  type: 'onAddDialogDone',
  payload: { token },
})



// WEBPACK FOOTER //
// ./src/tokens/actions/onAddDialogDone.js